import { Const } from "../Const";
import { ShaderDataType } from "../RenderDriver/DriverDesign/RenderDevice/ShaderData";
import { Shader3D } from "../RenderEngine/RenderShader/Shader3D";
import { Component } from "../components/Component";
import { LayaGL } from "../layagl/LayaGL";
import { Vector2 } from "../maths/Vector2";
import { Vector4 } from "../maths/Vector4";
import { ShaderDefines2D } from "../webgl/shader/d2/ShaderDefines2D";
export var BaseRender2DType;
(function (BaseRender2DType) {
    BaseRender2DType[BaseRender2DType["baseRenderNode"] = 0] = "baseRenderNode";
    BaseRender2DType[BaseRender2DType["spine"] = 1] = "spine";
    BaseRender2DType[BaseRender2DType["particle"] = 2] = "particle";
    BaseRender2DType[BaseRender2DType["spineSimple"] = 3] = "spineSimple";
})(BaseRender2DType || (BaseRender2DType = {}));
export var Render2DOrderMode;
(function (Render2DOrderMode) {
    Render2DOrderMode[Render2DOrderMode["elementIndex"] = 0] = "elementIndex";
    Render2DOrderMode[Render2DOrderMode["ysort"] = 1] = "ysort";
})(Render2DOrderMode || (Render2DOrderMode = {}));
export class BaseRenderNode2D extends Component {
    static initBaseRender2DCommandEncoder() {
        BaseRenderNode2D.NMATRIX_0 = Shader3D.propertyNameToID("u_NMatrix_0");
        BaseRenderNode2D.NMATRIX_1 = Shader3D.propertyNameToID("u_NMatrix_1");
        BaseRenderNode2D.BASERENDER2DCOLOR = Shader3D.propertyNameToID("u_baseRenderColor");
        BaseRenderNode2D.BASERENDER2DTEXTURE = Shader3D.propertyNameToID("u_baseRender2DTexture");
        BaseRenderNode2D.BASERENDER2DTEXTURERANGE = Shader3D.propertyNameToID("u_baseRender2DTextureRange");
        BaseRenderNode2D.BASERENDERSIZE = Shader3D.propertyNameToID("u_baseRenderSize2D");
        BaseRenderNode2D.NORMAL2DTEXTURE = Shader3D.propertyNameToID("u_normal2DTexture");
        BaseRenderNode2D.NORMAL2DSTRENGTH = Shader3D.propertyNameToID("u_normal2DStrength");
        BaseRenderNode2D.SHADERDEFINE_BASERENDER2D = Shader3D.getDefineByName("BASERENDER2D");
        BaseRenderNode2D.SHADERDEFINE_LIGHT2D_ENABLE = Shader3D.getDefineByName("LIGHT2D_ENABLE");
        BaseRenderNode2D.SHADERDEFINE_LIGHT2D_EMPTY = Shader3D.getDefineByName("LIGHT2D_EMPTY");
        BaseRenderNode2D.SHADERDEFINE_LIGHT2D_ADDMODE = Shader3D.getDefineByName("LIGHT2D_SCENEMODE_ADD");
        BaseRenderNode2D.SHADERDEFINE_LIGHT2D_SUBMODE = Shader3D.getDefineByName("LIGHT2D_SCENEMODE_SUB");
        BaseRenderNode2D.SHADERDEFINE_LIGHT2D_NORMAL_PARAM = Shader3D.getDefineByName("LIGHT2D_NORMAL_PARAM");
        BaseRenderNode2D.SHADERDEFINE_CLIPMODE = Shader3D.getDefineByName("CLIPMODE");
        const commandUniform = LayaGL.renderDeviceFactory.createGlobalUniformMap("BaseRender2D");
        commandUniform.addShaderUniform(BaseRenderNode2D.NMATRIX_0, "u_NMatrix_0", ShaderDataType.Vector3);
        commandUniform.addShaderUniform(BaseRenderNode2D.NMATRIX_1, "u_NMatrix_1", ShaderDataType.Vector3);
        commandUniform.addShaderUniform(BaseRenderNode2D.BASERENDER2DCOLOR, "u_baseRenderColor", ShaderDataType.Color);
        commandUniform.addShaderUniform(BaseRenderNode2D.BASERENDER2DTEXTURE, "u_baseRender2DTexture", ShaderDataType.Texture2D);
        commandUniform.addShaderUniform(BaseRenderNode2D.BASERENDER2DTEXTURERANGE, "u_baseRender2DTextureRange", ShaderDataType.Vector4);
        commandUniform.addShaderUniform(BaseRenderNode2D.BASERENDERSIZE, "u_baseRenderSize2D", ShaderDataType.Vector2);
        commandUniform.addShaderUniform(BaseRenderNode2D.NORMAL2DTEXTURE, "u_normal2DTexture", ShaderDataType.Texture2D);
        commandUniform.addShaderUniform(BaseRenderNode2D.NORMAL2DSTRENGTH, "u_normal2DStrength", ShaderDataType.Float);
        commandUniform.addShaderUniform(ShaderDefines2D.UNIFORM_CLIPMATDIR, "u_clipMatDir", ShaderDataType.Vector4);
        commandUniform.addShaderUniform(ShaderDefines2D.UNIFORM_CLIPMATPOS, "u_clipMatPos", ShaderDataType.Vector2);
        commandUniform.addShaderUniform(ShaderDefines2D.UNIFORM_COLORALPHA, "u_colorAlpha", ShaderDataType.Vector4);
        commandUniform.addShaderUniform(ShaderDefines2D.UNIFORM_COLORMAT, "u_colorMat", ShaderDataType.Matrix4x4);
    }
    static _setRenderElement2DMaterial(element, material) {
        element.subShader = material._shader.getSubShaderAt(0);
        material._setOwner2DElement(element);
        element.materialShaderData = material._shaderValues;
    }
    get renderLayer() {
        return this._renderLayer;
    }
    set renderLayer(value) {
        this._renderLayer = value;
    }
    get rect() {
        return this._rect;
    }
    set rect(value) {
        this._rect = value;
    }
    _getcommonUniformMap() {
        return ["BaseRender2D"];
    }
    _getRect() {
        return this._rect;
    }
    _transformChange() {
    }
    _changeMaterialReference(lastValue, value) {
        (lastValue) && (lastValue._removeReference());
        (value) && (value._addReference());
    }
    _setRenderSize(x, y) {
        if (x == this._rtsize.x && y == this._rtsize.y)
            return;
        this._rtsize.setValue(x, y);
        this._spriteShaderData.setVector2(BaseRenderNode2D.BASERENDERSIZE, this._rtsize);
    }
    constructor() {
        super();
        this._renderType = BaseRender2DType.baseRenderNode;
        this._renderUpdateMask = 0;
        this._layer = 0;
        this._rtsize = new Vector2();
        this._lightReceive = false;
        this._lightUpdateMark = 0;
        this._lightRecord = false;
        this._renderLayer = 1;
        this._rect = new Vector4();
        this._renderid = BaseRenderNode2D._uniqueIDCounter++;
        this._spriteShaderData = LayaGL.renderDeviceFactory.createShaderData(null);
        this._spriteShaderData.setVector(ShaderDefines2D.UNIFORM_CLIPMATDIR, new Vector4(Const.MAX_CLIP_SIZE, 0, 0, Const.MAX_CLIP_SIZE));
        this._renderType = BaseRender2DType.baseRenderNode;
        this._ordingMode = Render2DOrderMode.elementIndex;
    }
    _onEnable() {
        super._onEnable();
        this.owner.renderNode2D = this;
        if (this._lightReceive)
            this._addRenderToLightManager();
    }
    _onDisable() {
        this.owner.renderNode2D = null;
        if (this._lightReceive)
            this._removeRenderFromLightManager();
        super._onDisable();
    }
    _onDestroy() {
        for (var i = 0, n = this._materials.length; i < n; i++) {
            let m = this._materials[i];
            m && !m.destroyed && m._removeReference();
        }
        this._spriteShaderData.destroy();
    }
    get layer() {
        return this._layer;
    }
    set layer(value) {
        if (this._layer !== value) {
            if (value >= 0 && value <= 30) {
                this._removeRenderFromLightManager();
                this._layer = value;
                this._addRenderToLightManager();
                this._resetUpdateMark();
            }
            else {
                throw new Error("Layer value must be 0-30.");
            }
        }
    }
    set lightReceive(value) {
        if (value === this._lightReceive)
            return;
        this._lightReceive = value;
        if (value) {
            this._addRenderToLightManager();
            this._spriteShaderData.addDefine(BaseRenderNode2D.SHADERDEFINE_LIGHT2D_ENABLE);
        }
        else {
            this._removeRenderFromLightManager();
            this._spriteShaderData.removeDefine(BaseRenderNode2D.SHADERDEFINE_LIGHT2D_ENABLE);
        }
        this._resetUpdateMark();
    }
    get lightReceive() {
        return this._lightReceive;
    }
    _resetUpdateMark() {
        this._lightUpdateMark = 0;
    }
    _updateLight() {
        if (!this.lightReceive || !this.owner.scene || !this.owner.scene._light2DManager)
            return;
        const light2DManager = this.owner.scene._light2DManager;
        const updateMark = light2DManager._getLayerUpdateMark(this.layer);
        if (this._lightUpdateMark !== updateMark) {
            this._lightUpdateMark = updateMark;
            light2DManager._updateShaderDataByLayer(this.layer, this._spriteShaderData);
        }
    }
    _addRenderToLightManager() {
        if (this.owner.scene) {
            let light2DManager = this.owner.scene._light2DManager;
            if (light2DManager && !this._lightRecord) {
                light2DManager.addRender(this);
                this._lightRecord = true;
            }
        }
    }
    _removeRenderFromLightManager() {
        if (this.owner.scene) {
            const light2DManager = this.owner.scene._light2DManager;
            if (light2DManager && this._lightRecord) {
                light2DManager.removeRender(this);
                this._lightRecord = false;
            }
        }
    }
    get sharedMaterial() {
        return this._materials[0];
    }
    set sharedMaterial(value) {
        const lastValue = this._materials[0];
        if (lastValue !== value) {
            this._materials[0] = value;
            this._changeMaterialReference(lastValue, value);
            this._renderElements[0] && BaseRenderNode2D._setRenderElement2DMaterial(this._renderElements[0], value);
        }
    }
    getRenderID() {
        return this._renderid;
    }
    clear() {
        this._renderElements.length = 0;
    }
}
BaseRenderNode2D._uniqueIDCounter = 0;
